import React from "react";
import {
 Box,
 Heading,
 Accordion,
 AccordionItem,
 AccordionButton,
 AccordionPanel,
 AccordionIcon,
 List,
 ListItem,
 Badge,
 Flex,
 Text,
} from "@chakra-ui/react";

const CutoffSection = ({ cutoffs }) => {
 if (!cutoffs || Object.keys(cutoffs).length === 0) {
  return null;
 }

 return (
  <Box mb={8}>
   <Heading as="h2" size="md" mb={4}>
    Expected Cutoffs
   </Heading>

   <Accordion allowMultiple defaultIndex={[0]} borderRadius="md" boxShadow="sm">
    {cutoffs.map((cutoff, index) => {
     const examName = cutoff.exam;
     const cutoffData = cutoff.expectedCutoffGeneral;

     if (typeof cutoffData === "string") {
      return (
       <AccordionItem key={index} border="1px" borderColor="gray.200">
        <h3>
         <AccordionButton py={3} _expanded={{ bg: "blue.50" }}>
          <Box flex="1" textAlign="left" fontWeight="semibold">
           {examName}
          </Box>
          <AccordionIcon />
         </AccordionButton>
        </h3>
        <AccordionPanel pb={4} bg="gray.50">
         <Text>{cutoffData}</Text>
        </AccordionPanel>
       </AccordionItem>
      );
     } else if (typeof cutoffData === "object") {
      return (
       <AccordionItem key={index} border="1px" borderColor="gray.200">
        <h3>
         <AccordionButton py={3} _expanded={{ bg: "blue.50" }}>
          <Box flex="1" textAlign="left" fontWeight="semibold">
           {examName}
          </Box>
          <AccordionIcon />
         </AccordionButton>
        </h3>
        <AccordionPanel pb={4} bg="gray.50">
         <List spacing={2}>
          {Object.entries(cutoffData).map(([spec, cutoff], idx) => (
           <ListItem key={idx}>
            <Flex justify="space-between" align="center">
             <Text fontWeight="medium">{spec}</Text>
             <Badge colorScheme="blue" fontSize="0.8em" py={1} px={2}>
              {cutoff}
             </Badge>
            </Flex>
           </ListItem>
          ))}
         </List>
        </AccordionPanel>
       </AccordionItem>
      );
     } else {
      return null;
     }
    })}
   </Accordion>
  </Box>
 );
};

export default CutoffSection;

// import React from "react";
// import {
//  Box,
//  Heading,
//  Accordion,
//  AccordionItem,
//  AccordionButton,
//  AccordionPanel,
//  AccordionIcon,
//  List,
//  ListItem,
//  Badge,
//  Flex,
//  Text,
// } from "@chakra-ui/react";

// const CutoffSection = ({ cutoffs }) => {
//  if (!cutoffs || Object.keys(cutoffs).length === 0) {
//   return null;
//  }

//  return (
//   <Box mb={8}>
//    <Heading as="h2" size="md" mb={4}>
//     Expected Cutoffs
//    </Heading>

//    <Accordion allowMultiple defaultIndex={[0]} borderRadius="md" boxShadow="sm">
//     {Object.entries(cutoffs).map(([examName, specializations], index) => (
//      <AccordionItem key={index} border="1px" borderColor="gray.200">
//       <h3>
//        <AccordionButton py={3} _expanded={{ bg: "blue.50" }}>
//         <Box flex="1" textAlign="left" fontWeight="semibold">
//          {examName}
//         </Box>
//         <AccordionIcon />
//        </AccordionButton>
//       </h3>
//       <AccordionPanel pb={4} bg="gray.50">
//        <List spacing={2}>
//         {Object.entries(specializations).map(([spec, cutoff], idx) => (
//          <ListItem key={idx}>
//           <Flex justify="space-between" align="center">
//            <Text fontWeight="medium">{spec}</Text>
//            <Badge colorScheme="blue" fontSize="0.8em" py={1} px={2}>
//             {cutoff}
//            </Badge>
//           </Flex>
//          </ListItem>
//         ))}
//        </List>
//       </AccordionPanel>
//      </AccordionItem>
//     ))}
//    </Accordion>
//   </Box>
//  );
// };

// export default CutoffSection;
